var Highcharts = require('highcharts');

interface workzonescope extends ng.IScope {
    vm: any;
}

var theme2 = {
    colors: ['#FF7221', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
        '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
    title: {
        margin: 20,
        style: {
            align: "center",
            color: '#c8c8c8',
            "font-size": '26px'

        }
    },
    chart: {
        "backgroundColor": "rgb(45,45,45)",
        "borderColor": "rgb(0,0,0)",
        "spacingTop": 18,
        "marginTop": 42,
        "marginBottom": 76,
        "spacingBottom": 24
    },
    legend: {
        "enabled": false,
        "margin": 0,
        "itemStyle": {
            "color": "#C0C0C0 ",
        },
        "itemHoverStyle": {
            "color": "#C0C0C0 "
        },
        "itemHiddenStyle": {
            "color": "#444444 "
        }
    },
    xAxis: {
        "gridLineColor": "#525252 ",
        "gridLineWidth": 1,
        "labels": {
            "style": {
                "color": "#FFFFFF ",
                "font-size": '26px'
            },
            'y': 36
        },
        "lineColor": "#525252 ",
        "tickColor": "#525252 ",
        "title": {
            "style": {
                "color": "#c8c8c8 ",
                "font-size": '22px'
            },
            'y': -28,
            'margin': 15
        }
    },
    yAxis: {
        "gridLineColor": "#525252",
        "gridLineWidth": 1,
        "labels": {
            "style": {
                "color": "#FFFFFF",
                "font-size": '22px'
            },
            "y": 6,
            "lineColor": "#525252",
            "tickColor": "#525252",
            "title": {
                "style": {
                    "color": "#FFFFFF",
                    "font-size": '26px'
                }
            }
        }
    },
    plotOptions: {
        "column": {
            "borderColor": "rgb(0,0,0)",
            "borderWidth": "0"
        },
        "series": {
            "dataLabels": {
                "enabled": false
            }
        }
    }
}

class WorkZones implements ng.IDirective {
    transclude = true;
    restrict = 'E';
    scope = {
        info: "="
    };
    template = require('./template.workzones.html');
    public controller = 'workzonesController';
    public controllerAs = 'vm';
    public bindToController = true;

    public link: (scope: workzonescope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller) => void;

    constructor() {
        WorkZones.prototype.link = (scope: workzonescope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller) => {
            $(document).ready(function() {
                scope.$on("workzone_data_ready", function() {
                    Highcharts.setOptions(theme2);

                    // workaround to fix incorrect tooltip when the screen is scaled.
                    Highcharts.wrap(Highcharts.Pointer.prototype, 'normalize', function(proceed, event, chartPosition) {
                        var e = proceed.call(this, event, chartPosition);
                        var element = this.chart.container;
                        if (element && element.offsetWidth && element.offsetHeight) {

                            var scaleX = element.getBoundingClientRect().width / element.offsetWidth;
                            var scaleY = element.getBoundingClientRect().height / element.offsetHeight;
                            if (scaleX !== 1) {
                                e.chartX = e.chartX / scaleX;
                            }
                            if (scaleY !== 1) {
                                e.chartY = e.chartY / scaleY;
                            }
                        }
                        return e;
                    });

                    // Create the data series.
                    let seriesDataConstruction = [{
                        name: "Construction",
                        data: controller.districtList["CONSTRUCTION"]
                    }];

                    controller.chart = new Highcharts.Chart({
                        chart: {
                            type: 'column',
                            renderTo: "workZonesConstruction",
                            zoomType: 'xy',
                            title: {
                                enabled: true,
                                useHTML: true,
                                text: 'Construction',
                                style: {
                                    visibility: 'visible'
                                }
                            }
                        },
                        xAxis: {
                            categories: controller.districtList.district,
                            tickmarkPlacement: 'on',
                            title: {
                                text: 'District'
                            }
                        },
                        title: {
                            enabled: true,
                            useHTML: false,
                            text: 'Construction Zones by District',
                            align: "center",
                            margin: 20,
                            style: {
                                visibility: 'visible'
                            }
                        },
                        yAxis: {
                            floor: 0,
                            title: false,
                            allowDecimals: false,
                            labels: {
                                formatter: function() {
                                    return this.value;
                                }
                            }
                        },
                        tooltip: {
                            headerFormat: 'District {point.x}<br>',
                            pointFormat: '{series.name}: {point.y}<br>',
                            shared: true
                        },
                        series: seriesDataConstruction,
                        credits: {
                            enabled: false
                        }
                    });

                    // Workaround for the highchart control not rendering the entire container width.
                    setTimeout(() =>
                    {
                        controller.chart.reflow();
                    }, 0);
                });
            });
        }
    };

    public static Factory() {
        var directive = () => {
            return new WorkZones();
        }
        return directive;
    }
}

export default WorkZones;



// WEBPACK FOOTER //
// ./src/app/workzones/directive.workzones.ts